import dayjs from 'dayjs';
import { PiCertificateBold } from "react-icons/pi";
import { CERTIFICATES } from "../data";

function Certificates() {
    return (
      <section className="fade-in">
        <h2>Certificates and Continued Learning</h2>
          {CERTIFICATES.map((certificateItem, index) => (
            <div key={index}>
              <div className="container">
                <div className="heading-4">
                  { certificateItem.certification && <PiCertificateBold title="Certificate" /> }
                  {certificateItem.topic}
                </div>
                
                <div className="date">
                  {(certificateItem.endDate != null) ? dayjs(certificateItem.endDate).format('MMM YYYY') : "Present" }
                </div>
              </div>
              <div className="indent distribute">
                <span>{certificateItem.sponsor}</span>
              </div>
            </div>
          ))}
      </section>
    );
  }
  
export default Certificates;